import { render, staticRenderFns } from "./chat-file-menu.vue?vue&type=template&id=7b2016f4&scoped=true"
import script from "./chat-file-menu.vue?vue&type=script&lang=js"
export * from "./chat-file-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2016f4",
  null
  
)

export default component.exports